import { default as index2JUnpyHXBBMeta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93Dczl8ICOV4Meta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/[location_id]/[...slug].vue?macro=true";
import { default as checkoutSkKxXAVEm1Meta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/[location_id]/booking/checkout.vue?macro=true";
import { default as finishedZhhXEPjRU3Meta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/[location_id]/booking/finished.vue?macro=true";
import { default as review_45and_45confirmS7fDnvmUjGMeta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/[location_id]/booking/review-and-confirm.vue?macro=true";
import { default as servicesGvNfCf3s8MMeta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/[location_id]/booking/services.vue?macro=true";
import { default as timespybPwgnGs5Meta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/[location_id]/booking/times.vue?macro=true";
import { default as staff0U7uIuVDuEMeta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/[location_id]/staff.vue?macro=true";
import { default as about_45usKZZ75tFqzHMeta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/about-us.vue?macro=true";
import { default as closedwo1xHInK8mMeta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/closed.vue?macro=true";
import { default as indexKUBGAV0qbSMeta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/index.vue?macro=true";
import { default as mobile_45verificationQUX9GEAqS4Meta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/mobile-verification.vue?macro=true";
import { default as complete6niECROM9OMeta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/profile/complete.vue?macro=true";
import { default as indexoKgyx9vuSmMeta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/profile/index.vue?macro=true";
import { default as my_45bookingsK2bAYEbmI3Meta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/profile/my-bookings.vue?macro=true";
import { default as sign_45inRn0cy8GPGhMeta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/sign-in.vue?macro=true";
import { default as book_45againzk71Tbk1WUMeta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/book-again.vue?macro=true";
import { default as bookingsDx37FLu5G2Meta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/bookings.vue?macro=true";
import { default as change_45mobileOH51PjIWTUMeta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/change-mobile.vue?macro=true";
import { default as complete4BpqYB1MT6Meta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/complete.vue?macro=true";
import { default as editnxERDJpE6yMeta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/edit.vue?macro=true";
import { default as indextbqiYNWDPcMeta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/index.vue?macro=true";
import { default as mobile_45verificationeuDgPnUw9gMeta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/mobile-verification.vue?macro=true";
import { default as sign_45innZVcopL7J0Meta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/sign-in.vue?macro=true";
import { default as contact_45sales4QtGfkReT4Meta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/contact-sales.vue?macro=true";
import { default as contact_45us1aNO6BXd0FMeta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/contact-us.vue?macro=true";
import { default as privacy_45policySxKWixQoDHMeta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/privacy-policy.vue?macro=true";
import { default as request_45demo3OuZotRbgxMeta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/request-demo.vue?macro=true";
import { default as terms_45and_45conditions4xroi5ZBY0Meta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/terms-and-conditions.vue?macro=true";
import { default as whats_45bookforme8VlIZGKxTEMeta } from "/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/whats-bookforme.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: index2JUnpyHXBBMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/index.vue")
  },
  {
    name: "business_identifier-location_id-slug___en",
    path: "/en/:business_identifier()/:location_id()/:slug(.*)*",
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/[location_id]/[...slug].vue")
  },
  {
    name: "business_identifier-location_id-slug___ar",
    path: "/ar/:business_identifier()/:location_id()/:slug(.*)*",
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/[location_id]/[...slug].vue")
  },
  {
    name: "business_identifier-location_id-booking-checkout___en",
    path: "/en/:business_identifier()/:location_id()/booking/checkout",
    meta: checkoutSkKxXAVEm1Meta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/[location_id]/booking/checkout.vue")
  },
  {
    name: "business_identifier-location_id-booking-checkout___ar",
    path: "/ar/:business_identifier()/:location_id()/booking/checkout",
    meta: checkoutSkKxXAVEm1Meta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/[location_id]/booking/checkout.vue")
  },
  {
    name: "business_identifier-location_id-booking-finished___en",
    path: "/en/:business_identifier()/:location_id()/booking/finished",
    meta: finishedZhhXEPjRU3Meta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/[location_id]/booking/finished.vue")
  },
  {
    name: "business_identifier-location_id-booking-finished___ar",
    path: "/ar/:business_identifier()/:location_id()/booking/finished",
    meta: finishedZhhXEPjRU3Meta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/[location_id]/booking/finished.vue")
  },
  {
    name: "business_identifier-location_id-booking-review-and-confirm___en",
    path: "/en/:business_identifier()/:location_id()/booking/review-and-confirm",
    meta: review_45and_45confirmS7fDnvmUjGMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/[location_id]/booking/review-and-confirm.vue")
  },
  {
    name: "business_identifier-location_id-booking-review-and-confirm___ar",
    path: "/ar/:business_identifier()/:location_id()/booking/review-and-confirm",
    meta: review_45and_45confirmS7fDnvmUjGMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/[location_id]/booking/review-and-confirm.vue")
  },
  {
    name: "business_identifier-location_id-booking-services___en",
    path: "/en/:business_identifier()/:location_id()/booking/services",
    meta: servicesGvNfCf3s8MMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/[location_id]/booking/services.vue")
  },
  {
    name: "business_identifier-location_id-booking-services___ar",
    path: "/ar/:business_identifier()/:location_id()/booking/services",
    meta: servicesGvNfCf3s8MMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/[location_id]/booking/services.vue")
  },
  {
    name: "business_identifier-location_id-booking-times___en",
    path: "/en/:business_identifier()/:location_id()/booking/times",
    meta: timespybPwgnGs5Meta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/[location_id]/booking/times.vue")
  },
  {
    name: "business_identifier-location_id-booking-times___ar",
    path: "/ar/:business_identifier()/:location_id()/booking/times",
    meta: timespybPwgnGs5Meta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/[location_id]/booking/times.vue")
  },
  {
    name: "business_identifier-location_id-staff___en",
    path: "/en/:business_identifier()/:location_id()/staff",
    meta: staff0U7uIuVDuEMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/[location_id]/staff.vue")
  },
  {
    name: "business_identifier-location_id-staff___ar",
    path: "/ar/:business_identifier()/:location_id()/staff",
    meta: staff0U7uIuVDuEMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/[location_id]/staff.vue")
  },
  {
    name: "business_identifier-about-us___en",
    path: "/en/:business_identifier()/about-us",
    meta: about_45usKZZ75tFqzHMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/about-us.vue")
  },
  {
    name: "business_identifier-about-us___ar",
    path: "/ar/:business_identifier()/about-us",
    meta: about_45usKZZ75tFqzHMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/about-us.vue")
  },
  {
    name: "business_identifier-closed___en",
    path: "/en/:business_identifier()/closed",
    meta: closedwo1xHInK8mMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/closed.vue")
  },
  {
    name: "business_identifier-closed___ar",
    path: "/ar/:business_identifier()/closed",
    meta: closedwo1xHInK8mMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/closed.vue")
  },
  {
    name: "business_identifier___en",
    path: "/en/:business_identifier()",
    meta: indexKUBGAV0qbSMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/index.vue")
  },
  {
    name: "business_identifier___ar",
    path: "/ar/:business_identifier()",
    meta: indexKUBGAV0qbSMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/index.vue")
  },
  {
    name: "business_identifier-mobile-verification___en",
    path: "/en/:business_identifier()/mobile-verification",
    meta: mobile_45verificationQUX9GEAqS4Meta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/mobile-verification.vue")
  },
  {
    name: "business_identifier-mobile-verification___ar",
    path: "/ar/:business_identifier()/mobile-verification",
    meta: mobile_45verificationQUX9GEAqS4Meta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/mobile-verification.vue")
  },
  {
    name: "business_identifier-profile-complete___en",
    path: "/en/:business_identifier()/profile/complete",
    meta: complete6niECROM9OMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/profile/complete.vue")
  },
  {
    name: "business_identifier-profile-complete___ar",
    path: "/ar/:business_identifier()/profile/complete",
    meta: complete6niECROM9OMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/profile/complete.vue")
  },
  {
    name: "business_identifier-profile___en",
    path: "/en/:business_identifier()/profile",
    meta: indexoKgyx9vuSmMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/profile/index.vue")
  },
  {
    name: "business_identifier-profile___ar",
    path: "/ar/:business_identifier()/profile",
    meta: indexoKgyx9vuSmMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/profile/index.vue")
  },
  {
    name: "business_identifier-profile-my-bookings___en",
    path: "/en/:business_identifier()/profile/my-bookings",
    meta: my_45bookingsK2bAYEbmI3Meta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/profile/my-bookings.vue")
  },
  {
    name: "business_identifier-profile-my-bookings___ar",
    path: "/ar/:business_identifier()/profile/my-bookings",
    meta: my_45bookingsK2bAYEbmI3Meta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/profile/my-bookings.vue")
  },
  {
    name: "business_identifier-sign-in___en",
    path: "/en/:business_identifier()/sign-in",
    meta: sign_45inRn0cy8GPGhMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/sign-in.vue")
  },
  {
    name: "business_identifier-sign-in___ar",
    path: "/ar/:business_identifier()/sign-in",
    meta: sign_45inRn0cy8GPGhMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/[business_identifier]/sign-in.vue")
  },
  {
    name: "account-book-again___en",
    path: "/en/account/book-again",
    meta: book_45againzk71Tbk1WUMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/book-again.vue")
  },
  {
    name: "account-book-again___ar",
    path: "/ar/account/book-again",
    meta: book_45againzk71Tbk1WUMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/book-again.vue")
  },
  {
    name: "account-bookings___en",
    path: "/en/account/bookings",
    meta: bookingsDx37FLu5G2Meta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/bookings.vue")
  },
  {
    name: "account-bookings___ar",
    path: "/ar/account/bookings",
    meta: bookingsDx37FLu5G2Meta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/bookings.vue")
  },
  {
    name: "account-change-mobile___en",
    path: "/en/account/change-mobile",
    meta: change_45mobileOH51PjIWTUMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/change-mobile.vue")
  },
  {
    name: "account-change-mobile___ar",
    path: "/ar/account/change-mobile",
    meta: change_45mobileOH51PjIWTUMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/change-mobile.vue")
  },
  {
    name: "account-complete___en",
    path: "/en/account/complete",
    meta: complete4BpqYB1MT6Meta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/complete.vue")
  },
  {
    name: "account-complete___ar",
    path: "/ar/account/complete",
    meta: complete4BpqYB1MT6Meta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/complete.vue")
  },
  {
    name: "account-edit___en",
    path: "/en/account/edit",
    meta: editnxERDJpE6yMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/edit.vue")
  },
  {
    name: "account-edit___ar",
    path: "/ar/account/edit",
    meta: editnxERDJpE6yMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/edit.vue")
  },
  {
    name: "account___en",
    path: "/en/account",
    meta: indextbqiYNWDPcMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/index.vue")
  },
  {
    name: "account___ar",
    path: "/ar/account",
    meta: indextbqiYNWDPcMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/index.vue")
  },
  {
    name: "account-mobile-verification___en",
    path: "/en/account/mobile-verification",
    meta: mobile_45verificationeuDgPnUw9gMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/mobile-verification.vue")
  },
  {
    name: "account-mobile-verification___ar",
    path: "/ar/account/mobile-verification",
    meta: mobile_45verificationeuDgPnUw9gMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/mobile-verification.vue")
  },
  {
    name: "account-sign-in___en",
    path: "/en/account/sign-in",
    meta: sign_45innZVcopL7J0Meta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/sign-in.vue")
  },
  {
    name: "account-sign-in___ar",
    path: "/ar/account/sign-in",
    meta: sign_45innZVcopL7J0Meta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/account/sign-in.vue")
  },
  {
    name: "contact-sales___en",
    path: "/en/contact-sales",
    meta: contact_45sales4QtGfkReT4Meta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/contact-sales.vue")
  },
  {
    name: "contact-sales___ar",
    path: "/ar/contact-sales",
    meta: contact_45sales4QtGfkReT4Meta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/contact-sales.vue")
  },
  {
    name: "contact-us___en",
    path: "/en/contact-us",
    meta: contact_45us1aNO6BXd0FMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/contact-us.vue")
  },
  {
    name: "contact-us___ar",
    path: "/ar/contact-us",
    meta: contact_45us1aNO6BXd0FMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/contact-us.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: index2JUnpyHXBBMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    meta: index2JUnpyHXBBMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/index.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/en/privacy-policy",
    meta: privacy_45policySxKWixQoDHMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___ar",
    path: "/ar/privacy-policy",
    meta: privacy_45policySxKWixQoDHMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/privacy-policy.vue")
  },
  {
    name: "request-demo___en",
    path: "/en/request-demo",
    meta: request_45demo3OuZotRbgxMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/request-demo.vue")
  },
  {
    name: "request-demo___ar",
    path: "/ar/request-demo",
    meta: request_45demo3OuZotRbgxMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/request-demo.vue")
  },
  {
    name: "terms-and-conditions___en",
    path: "/en/terms-and-conditions",
    meta: terms_45and_45conditions4xroi5ZBY0Meta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___ar",
    path: "/ar/terms-and-conditions",
    meta: terms_45and_45conditions4xroi5ZBY0Meta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/terms-and-conditions.vue")
  },
  {
    name: "whats-bookforme___en",
    path: "/en/whats-bookforme",
    meta: whats_45bookforme8VlIZGKxTEMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/whats-bookforme.vue")
  },
  {
    name: "whats-bookforme___ar",
    path: "/ar/whats-bookforme",
    meta: whats_45bookforme8VlIZGKxTEMeta || {},
    component: () => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/pages/whats-bookforme.vue")
  }
]